import { useEffect } from "react";
import { Modal, Button, Form, notification } from "antd";

import { POST } from "../../../../providers/useAxiosQuery";
import FloatInputPassword from "../../../../providers/FloatInputPassword";
import validateRules from "../../../../providers/validateRules";
import notificationErrors from "../../../../providers/notificationErrors";

export default function ModalAuthPassword(props) {
	const {
		toggleModalAuthPassword,
		setToggleModalAuthPassword,
		handleFinish,
	} = props;

	// console.log("toggleModalAuthPassword: ", toggleModalAuthPassword);
	const [form] = Form.useForm();
	const {
		mutate: mutateMultipleApplicantAuth,
		isLoading: isLoadingMultipleApplicantAuth,
	} = POST(`api/authorization_prompt`, "student_exams_list");

	const onFinish = (values) => {
		const { tableFilter, data, from } = toggleModalAuthPassword;

		const tabActive = tableFilter?.tabActive;
		const commonPayload = {
			...values,
			from: tabActive || from,
			link_origin: window.location.origin,
		};

		let payload;

		switch (tabActive) {
			case "Exam Status List View":
				payload = {
					...commonPayload,
					newValues: data?.map(
						({ id, fullname, exam_sheet_number, exam_status }) => ({
							id,
							fullname: fullname ?? null,
							exam_sheet_number: exam_sheet_number ?? null,
							exam_status: exam_status ?? null,
						})
					),
				};
				break;
			case "Exam Result List View":
				const formData = new FormData();
				formData.append(
					"exam_category_id",
					parseInt(data?.exam_category_id, 10)
				);
				if (data?.file_excel?.[0]?.originFileObj) {
					formData.append("file_excel", data.file_excel[0].originFileObj);
				}
				formData.append("from", "Exam Result List View");
				formData.append("link_origin", window.location.origin);
				formData.append("auth_password", commonPayload.auth_password);
				payload = formData;
				break;
			default:
				switch (from) {
					// case "Profile Validation List View":
					// 	payload = {
					// 		...commonPayload,
					// 		newValues: {
					// 			...data,
					// 			exam_schedule_id: toggleModalAuthPassword.exam_schedule_id,
					// 		},
					// 	};
					// 	break;
					case "Payment Approval List View":
						payload = { ...commonPayload, newValues: data };
						break;
					default:
						handleFinish(data, commonPayload.auth_password);
						console.log("HERE im here");
						return; // Exit the function early to avoid calling mutateMultipleApplicantAuth
				}
		}

		mutateMultipleApplicantAuth(payload, {
			onSuccess: (res) => {
				if (res.success) {
					notification.success({
						message: "Success",
						description: res.message,
					});
					form.resetFields();
					setToggleModalAuthPassword({
						open: false,
						data: null,
						// from: "Profile Validation List View",
					});
				} else {
					notification.error({
						message: "Failed",
						description: res.message,
					});
				}
			},
			onError: notificationErrors,
		});
	};

	useEffect(() => {
		if (toggleModalAuthPassword.open) {
			form.resetFields();
		}
	}, [toggleModalAuthPassword]);

	return (
		<Modal
			title="Authentication Required"
			open={toggleModalAuthPassword.open}
			onCancel={() => {
				setToggleModalAuthPassword({
					open: false,
					data: null,
				});
				form.resetFields();
			}}
			footer={[
				<Button
					className="btn-main-primary outlined"
					key={1}
					onClick={() => {
						setToggleModalAuthPassword({
							open: false,
							data: null,
						});
						form.resetFields();
					}}
				>
					CANCEL
				</Button>,
				<Button
					className="btn-main-primary"
					htmlType="submit"
					type="primary"
					key={2}
					loading={isLoadingMultipleApplicantAuth}
					onClick={() => form.submit()}
				>
					SUBMIT
				</Button>,
			]}
		>
			<Form form={form} onFinish={onFinish}>
				<Form.Item name="auth_password" rules={[validateRules.quillValidator]}>
					<FloatInputPassword
						label="Password"
						placeholder="Password"
						required
					/>
				</Form.Item>
			</Form>
		</Modal>
	);
}
